import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

type DeactivateApplyLinkModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  name: string;
  onCancel: () => void;
  onConfirm: () => void;
};

export function DeactivateApplyLinkModal(props: DeactivateApplyLinkModalProps) {
  const { t } = useTranslation();
  const { isOpen, onCancel, onConfirm, name, isLoading } = props;

  return (
    <Modal isOpen={isOpen} testID="deactivate-apply-link-modal">
      <Dialog>
        <DialogHeader onClose={onCancel}>
          {t("Deactivate ") + name}
        </DialogHeader>
        <DialogContent>
          {t(
            "By clicking 'Deactivate', any applicants who click on this link will not be able to start this background check. Any cases already created using this link will not be affected."
          )}
        </DialogContent>
        <DialogFooter>
          <BasicButton size="medium" onPress={onCancel} testID="cancel-button">
            <Trans>Cancel</Trans>
          </BasicButton>
          <DangerButton
            type="submit"
            size="medium"
            isLoading={isLoading}
            onPress={() => onConfirm()}
            testID="deactivate-confirm-button"
          >
            <Trans>Deactivate</Trans>
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
